<div class="container">
  <!-- section title -->

  <div class='spacer-20'></div>

  <h2 class="section-title wow fadeInUp">{{ 'sections.programs.javaScriptBeginner.titleCourse' | translate}}!</h2>
  <div class="spacer-20"></div>
  <h6 class='ml-lg-3'>{{ 'sections.programs.javaScriptBeginner.paragraph2' | translate}}!</h6>

  <p class='ml-lg-3'>{{ 'sections.programs.javaScriptBeginner.courseTimeFrame' | translate}}</p>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-6">
      <!-- timeline wrapper -->
      <div class="timeline edu rounded bg-white shadow-dark padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part1.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part1.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part1.contents.one' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part1.contents.two' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part1.contents.three' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part2.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part2.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part2.contents.one' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part2.contents.two' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part2.contents.three' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part2.contents.four' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part3.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part3.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part3.contents.one' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part3.contents.two' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part3.contents.three' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part3.contents.four' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>

    <div class="col-md-6">
      <!-- responsive spacer -->
      <div class="spacer-30 d-md-none d-lg-none"></div>

      <!-- timeline wrapper -->
      <div class="timeline exp bg-white shadow-dark rounded padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part4.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part4.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part4.contents.one' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part4.contents.two' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part4.contents.three' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part5.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part5.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part5.contents.one' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part5.contents.two' | translate }}</li>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part5.contents.three' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">{{ 'sections.programs.javaScriptBeginner.curriculum.part6.part' | translate }}</span>
            <h3 class="title">{{ 'sections.programs.javaScriptBeginner.curriculum.part6.title' | translate }}</h3>
            <ul class='ml-3'>
              <li>{{ 'sections.programs.javaScriptBeginner.curriculum.part5.contents.one' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>
  </div>
</div>
